<template>
  <a :class="classes" href="javascript:void(0);" @click.prevent.stop="toggle">
    <span class="dn-chk-btn__faux"><dn-icon icon="check" /></span>
    <span class="dn-chk-btn__label" v-if="$slots.default"><slot /></span>
  </a>
</template>



<script>
import Selectable from 'ui/mixins/selectable';



export default {
  mixins: [Selectable],

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
    }
  },

  computed: {
    classes() {
      return {
        'dn-chk-btn': true,
        'dn-chk-btn--checked': this.isActive,
        'dn-chk-btn--disabled': this.disabled,
        'dn-chk-btn--noaction': this.noaction,
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// ChkBtn.vue?5ce72361